<div class="main-wrapper">
    <div class="header" *ngIf="this.showHeaderLogo">
    </div>
    <div class="content-section">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h4 class="top-part-name">
                        Quoting
                        <span *ngIf="this.currentPart">({{ this.currentPart.partName }})</span>
                        <span *ngIf="this.rfqData.rfqPartList.length > 1">({{ this.partRangeText }})</span>
                    </h4>
                </div>
            </div>
            <div class="quote-assist-sec">
                <div class="d-flex gap-2 row-reverse device-height">
                    <div class="col-md-4">
                        <div class="left-section">
                            <div class="rfq-name-sec">
                                <div class="d-flex align-items-center gap-2">
                                    <div class="rfq-image" style="display: none;">
                                        <img src="assets/img/svg/thumbnail.svg" alt="Thumbnail" />
                                    </div>
                                    <div class="rfq-name text-ellipsis">
                                        <h4 *ngIf="this.rfqData" [title]="this.rfqData.rfqName">{{ this.rfqData.rfqName }}</h4>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center">
                                    <button type="button" class="light-btn" (click)="openPartFileInNewTab()">View Part</button>
                                </div>
                            </div>
                            <div class="inner-section">
                                <div class="summary-sec">
                                    <div class="otto-icon">
                                        <img src="assets/img/svg/otto-icon.svg" alt="OTTO-icon" />
                                    </div>
                                    <div class="summary-text">
                                        <ng-container *ngFor="let chat of quoteAttributesSection.chatHistory">
                                            <p>
                                                {{ chat.Text }}
                                            </p>
                                        </ng-container>
                                    </div>
                                </div>

                            </div>
                            <div class="chat-box-sec" style="display: none;">
                                <div class="chat-container">
                                    <textarea class="form-control"
                                        placeholder="Message OTTO dms Quote Assist"></textarea>
                                    <div>
                                        <a href="#">
                                            <img src="assets/img/svg/voice-icon.svg" alt="Check-icon" />
                                        </a>
                                    </div>
                                    <div>
                                        <a href="#">
                                            <img src="assets/img/svg/msg-send.svg" alt="Check-icon" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="right-section">
                            <div class="material-row" style="display: none;" (click)="showSection(this.quoteAssistModel.complexityModel, true)"
                                [ngClass]="{'disabled-section-overlay': !quoteAssistModel.complexityModel.isDataLoaded}">
                                <div class="heading-sec">
                                    <div>
                                        <h5>Complexity
                                            <span class="complexity-text"
                                                *ngIf="this.quoteAssistModel.complexityModel.complexity">
                                                {{ this.quoteAssistModel.complexityModel.complexity }}
                                            </span>
                                        </h5>
                                    </div>
                                    <div>
                                        <img [src]="this.quoteAssistModel.complexityModel.isSectionCompleted ? 'assets/img/svg/green-check.svg' : 'assets/img/svg/gray-check.svg'"
                                            alt="Check-icon" />
                                    </div>
                                </div>
                                <div class="collapseable-container"
                                    *ngIf="this.quoteAssistModel.complexityModel.isVisible">
                                    <div class="progress-container">
                                        <div class="step-progress-bar">
                                            <input type="range" min="0" max="10"
                                                [(ngModel)]="quoteAssistModel.complexityModel.complexity" />
                                            <div class="steps">
                                                <div class="step active">Low</div>
                                                <div class="step">Medium</div>
                                                <div class="step">High</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="notification-sec">
                                        <div class="notification-icon">
                                            <img src="assets/img/svg/notification-icon.svg" alt="Notification-icon" />
                                        </div>
                                        <div class="notification-text">
                                            <p>
                                                The RFQ files suggest a ({{ quoteAssistModel.complexityModel.complexity
                                                }})
                                                complexity, which you can adjust.
                                                Higher complexity typically means higher costs.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <button type="button" class="light-dark-blue"
                                            [ngClass]="{'disabled-btn': !this.quoteAssistModel.materials.isDataLoaded}"
                                            (click)="continueClicked($event, quoteAssistModel.materials, quoteAssistModel.complexityModel)">Continue</button>
                                    </div>
                                </div>
                            </div>
                            <div class="material-row" (click)="showSection(this.quoteAssistModel.materials, true)"
                                [ngClass]="{'disabled-section-overlay': !quoteAssistModel.materials.isDataLoaded}">
                                <div class="heading-sec">
                                    <div>
                                        <h5>Material</h5>
                                    </div>
                                    <div>
                                        <img [src]="this.quoteAssistModel.materials.isSectionCompleted ? 'assets/img/svg/green-check.svg' : 'assets/img/svg/gray-check.svg'"
                                            alt="Check-icon" />
                                    </div>
                                </div>
                                <div class="collapseable-container" *ngIf="this.quoteAssistModel.materials.isVisible">
                                    <ng-container
                                        *ngFor="let materialItem of quoteAssistModel?.materials?.materialsList">
                                        <div class="row d-flex align-items-center mb-2 mt-3">
                                            <div class="col-md-8">
                                                <strong>Description</strong>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="editable-textbox input-group">
                                                    <input type="text" class="form-control"
                                                        [(ngModel)]="materialItem.name" placeholder="Material Name" />
                                                    <div class="input-group-append">
                                                        <span class="input-group-text">
                                                            <img src="assets/img/svg/pencil.svg" alt="Edit"
                                                                (click)="editItem(materialItem)" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="row d-flex align-items-center mb-2 mt-3">
                                            <div class="col-md-8">
                                                <strong>Total Material Cost ({{ this.currentPart.quoteAssistData.assistedQty }} Units)</strong>
                                                <div class="tooltip-container">
                                                    <img src="assets/img/svg/tooltip-icon.png" alt="Tooltip" class="tooltip-icon" (click)="toggleTooltip($event)">
                                                    <div class="tooltip-popup">
                                                        This cost is the total material cost for this part, not per unit. It is based on the bounding box from the file.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="editable-textbox input-group">
                                                    <div class="input-group-append dollar-sign">
                                                        <span class="input-group-text">$</span>
                                                    </div>
                                                    <input type="text" class="form-control"
                                                        [appFormatDecimal]="quoteAssistModel.materials.totalCost"
                                                        [(ngModel)]="quoteAssistModel.materials.totalCost"
                                                        placeholder="0.00"  />
                                                    <div class="input-group-append">
                                                        <span class="input-group-text">
                                                            <img src="assets/img/svg/pencil.svg" alt="Edit"
                                                                (click)="editItem(materialItem)" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <!-- New input field for custom material name -->
                                    <div class="d-flex align-items-center justify-content-end mb-2 mt-3 gap-2"
                                        style="display: none;">
                                        <div *ngIf="quoteAssistModel.materials?.addNewVisible"
                                            class="w-100 d-flex align-items-center gap-3">
                                            <div class="col-md-7">
                                                <div class="editable-textbox input-group">
                                                    <input type="text" class="form-control"
                                                        placeholder="Enter Material Name" #materialNameTextbox
                                                        (keydown.enter)="saveNewMaterialItem(materialCostTextbox, materialNameTextbox)" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="editable-textbox input-group">
                                                    <div class="input-group-append dollar-sign">
                                                        <span class="input-group-text">$</span>
                                                    </div>
                                                    <input type="text" class="form-control" placeholder="0.00"
                                                        #materialCostTextbox
                                                        (keydown.enter)="saveNewMaterialItem(materialCostTextbox, materialNameTextbox)" />
                                                </div>
                                            </div>
                                            <div class="col-md-1 pr-0"></div>
                                        </div>
                                        <div style="display: none;" class="plus-icon"
                                            [ngClass]="{'opened': quoteAssistModel.materials.addNewVisible}">
                                            <a (click)="toggleAddNewTemplate(quoteAssistModel.materials)">
                                                <i class="minus-plus-icon"></i>
                                            </a>
                                        </div>
                                    </div>

                                    <div class="notification-sec">
                                        <div class="notification-icon">
                                            <img src="assets/img/svg/notification-icon.svg" alt="Notification-icon" />
                                        </div>
                                        <div class="notification-text">
                                            <p>
                                                These estimates use market rates and part dimensions; confirm accuracy
                                                for
                                                your factors.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <button type="button" class="light-dark-blue"
                                            [ngClass]="{'disabled-btn': !this.quoteAssistModel.tooling.isDataLoaded}"
                                            (click)="continueClicked($event, quoteAssistModel.tooling, quoteAssistModel.materials)">Add To
                                            Quote</button>
                                    </div>
                                </div>
                            </div>
                            <div class="material-row" (click)="showSection(this.quoteAssistModel.tooling, true)"
                                [ngClass]="{'disabled-section-overlay': !this.quoteAssistModel.tooling.isDataLoaded}">
                                <div class="heading-sec">
                                    <div>
                                        <h5>Tooling</h5>
                                    </div>
                                    <div>
                                        <img [src]="this.quoteAssistModel.tooling.isSectionCompleted ? 'assets/img/svg/green-check.svg' : 'assets/img/svg/gray-check.svg'"
                                            alt="Check-icon" />
                                    </div>
                                </div>
                                <div class="collapseable-container" *ngIf="this.quoteAssistModel.tooling.isVisible">
                                    <p>Are there any tooling expenses associated with this quote?</p>
                                    <ng-container *ngFor="let toolingItem of quoteAssistModel?.tooling?.toolingList">
                                        <div *ngIf="toolingItem.category === 'Primary'"
                                            class="row d-flex align-items-center mb-2 mt-3">
                                            <div class="col-md-7" *ngIf="!toolingItem.isEditable">
                                                <strong>{{ toolingItem.toolName }}</strong>
                                            </div>
                                            <div class="col-md-7" *ngIf="toolingItem.isEditable">
                                                <div class="editable-textbox input-group">
                                                    <input type="text" class="form-control"
                                                        [(ngModel)]="toolingItem.toolName"
                                                        (keydown.enter)="editItem(toolingItem)"
                                                        placeholder="Tooling Name"  />
                                                </div>
                                            </div>
                                            <div class="col-md-4 pr-0">
                                                <div class="editable-textbox input-group">
                                                    <div class="input-group-append dollar-sign">
                                                        <span class="input-group-text">$</span>
                                                    </div>
                                                    <input type="text" class="form-control"
                                                        [(ngModel)]="toolingItem.estimatedCost"
                                                        (keydown.enter)="editItem(toolingItem)" placeholder="0.00"
                                                        [appFormatDecimal]="toolingItem.estimatedCost" />
                                                    <div class="input-group-append">
                                                        <span class="input-group-text">
                                                            <img src="assets/img/svg/pencil.svg" alt="Edit"
                                                                (click)="editItem(toolingItem)" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-1 d-flex align-items-center justify-content-end">
                                                <div class="remove-button" *ngIf="toolingItem.isEditable">
                                                    <a (click)="editItem(toolingItem)">
                                                        <img src="assets/img/svg/close-x-lg.svg" alt="Remove icon"
                                                            style="height: 20px;" />
                                                    </a>
                                                </div>
                                                <div class="remove-button"
                                                    *ngIf="(quoteAssistModel?.tooling?.toolingList?.length ?? 0) > 1 && !toolingItem.isEditable">
                                                    <a (click)="removeToolingItem(toolingItem)" style="display: none;">
                                                        <img src="assets/img/svg/delete-icon.svg" alt="Plus icon" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <!-- New input field for custom tooling name -->
                                    <div class="row d-flex align-items-center justify-content-end mb-2 mt-3">
                                        <ng-container *ngIf="quoteAssistModel.tooling.addNewVisible">
                                            <div class="col-md-7">
                                                <div class="editable-textbox input-group">
                                                    <input type="text" class="form-control"
                                                        placeholder="Enter custom tooling name"
                                                        [(ngModel)]="this.blankToolingSection.toolName"
                                                        (keydown.enter)="saveNewToolingItem()" />
                                                </div>
                                            </div>
                                            <div class="col-md-4 pr-0">
                                                <div class="editable-textbox input-group">
                                                    <div class="input-group-append dollar-sign">
                                                        <span class="input-group-text">$</span>
                                                    </div>
                                                    <input type="text" class="form-control" placeholder="0.00"
                                                        [(ngModel)]="this.blankToolingSection.estimatedCost" 
                                                        [appFormatDecimal]="this.blankToolingSection.estimatedCost"
                                                        (keydown.enter)="saveNewToolingItem()" />
                                                </div>
                                            </div>
                                        </ng-container>
                                        <div class="col-md-1 plus-icon" style="display: none;"
                                            [ngClass]="{'opened': quoteAssistModel.tooling.addNewVisible}">
                                            <a (click)="toggleAddNewTemplate(quoteAssistModel.tooling)">
                                                <i class="minus-plus-icon"></i>
                                            </a>
                                        </div>
                                    </div>

                                    <div class="notification-sec">
                                        <div class="notification-icon">
                                            <img src="assets/img/svg/notification-icon.svg" alt="Notification-icon" />
                                        </div>
                                        <div class="notification-text">
                                            <p>
                                                Include any tooling costs, especially for unique features like deep
                                                holes or
                                                undercuts.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <button type="button" class="light-dark-blue"
                                            [ngClass]="{'disabled-btn': !this.quoteAssistModel.manufacturingProcess.isDataLoaded}"
                                            (click)="continueClicked($event, this.quoteAssistModel.manufacturingProcess, this.quoteAssistModel.tooling)">Add
                                            To Quote</button>
                                    </div>
                                </div>
                            </div>
                            <div class="material-row" (click)="showSection(this.quoteAssistModel.manufacturingProcess, true)"
                                [ngClass]="{'disabled-section-overlay': !quoteAssistModel.manufacturingProcess.isDataLoaded}">
                                <div class="heading-sec">
                                    <div>
                                        <h5>Manufacturing Processes</h5>
                                    </div>
                                    <div>
                                        <img [src]="this.quoteAssistModel.manufacturingProcess.isSectionCompleted ? 'assets/img/svg/green-check.svg' : 'assets/img/svg/gray-check.svg'"
                                            alt="Check-icon" />
                                    </div>
                                </div>
                                <div class="collapseable-container"
                                    *ngIf="this.quoteAssistModel.manufacturingProcess.isVisible">
                                    <div class="row d-flex align-items-center mb-2 mt-2">
                                        <div class="col-md-3">
                                            <label class="form-label">Process Name</label>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label">Cycle Time (Mins/Unit)</label>
                                        </div>
                                        <div class="col-md-2 p-0">
                                            <label class="form-label">
                                                Machine Time
                                                <div class="tooltip-container">
                                                    <img src="assets/img/svg/tooltip-icon.png" alt="Tooltip" class="tooltip-icon" (click)="toggleTooltip($event)">
                                                    <div class="tooltip-popup">
                                                        The machine time is calculated by multiplying the total cycle by the number of units in this job.
                                                    </div>
                                                </div>

                                            </label>
                                        </div>
                                        <div class="col-md-3 pr-0">
                                            <label class="form-label">Setup Time (Mins)</label>
                                        </div>
                                    </div>
                                    <div *ngFor="let manufacturingItem of quoteAssistModel?.manufacturingProcess?.manufacturingList"
                                        class="row d-flex align-items-center mb-2 mt-2">
                                        <div class="col-md-3 pr-0" *ngIf="!manufacturingItem.isEditable">
                                            <label class="form-label">{{ manufacturingItem.processName }}</label>
                                        </div>
                                        <div class="col-md-3 pr-0" *ngIf="manufacturingItem.isEditable">
                                            <div class="editable-textbox input-group input-width">
                                                <input type="text" class="form-control" placeholder="Process Name"
                                                    [(ngModel)]="manufacturingItem.processName"
                                                    (keydown.enter)="editItem(manufacturingItem)" />
                                                <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        <img src="assets/img/svg/pencil.svg" alt="Edit"
                                                            (click)="editItem(manufacturingItem)" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="editable-textbox input-group d-flex align-items-center input-width">
                                                <input type="text" class="form-control" appOnlyPositiveNumbers
                                                    [(ngModel)]="manufacturingItem.cycleTimePerUnit"
                                                    placeholder="0" (change)="calculateMachineTime(manufacturingItem);" />
                                                <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        <img src="assets/img/svg/pencil.svg" alt="Edit"
                                                            (click)="editItem(manufacturingItem)" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2 p-0">
                                            <div class="editable-textbox input-group input-width">
                                            <input type="text" class="form-control disabled-input"
                                                [(ngModel)]="manufacturingItem.totalMachineTimeInMinutes"
                                                placeholder="0" disabled />
                                            </div>
                                        </div>
                                        <div class="col-md-3 pr-0">
                                            <div class="editable-textbox input-group input-width">
                                                <input type="text" class="form-control" placeholder="0" appOnlyPositiveNumbers
                                                    [(ngModel)]="manufacturingItem.totalLaborTimeInMinutes"
                                                    (keydown.enter)="editItem(manufacturingItem)" />
                                                <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        <img src="assets/img/svg/pencil.svg" alt="Edit"
                                                            (click)="editItem(manufacturingItem)" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-1 d-flex align-items-center justify-content-end">
                                            <div class="remove-button" *ngIf="manufacturingItem.isEditable">
                                                <a (click)="editItem(manufacturingItem)">
                                                    <img src="assets/img/svg/close-x-lg.svg" alt="Remove icon"
                                                        style="height: 20px;" />
                                                </a>
                                            </div>
                                            <div class="remove-button"
                                                *ngIf="!manufacturingItem.isEditable">
                                                <a (click)="removeManufacturingItem(manufacturingItem)">
                                                    <img src="assets/img/svg/delete-icon.svg" alt="Plus icon" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Add New Template for Manufacturing Starts -->
                                    <div class="row mt-3">
                                        <div class="col-md-12 plus-icon"
                                            [ngClass]="{'opened': quoteAssistModel.manufacturingProcess.addNewVisible}">
                                            <div class="icon-blue-line"></div>
                                            <a (click)="toggleAddNewTemplate(quoteAssistModel.manufacturingProcess)">
                                                <i class="minus-plus-icon"></i>
                                                Add Other Process
                                            </a>
                                            <div class="icon-blue-line"></div>
                                        </div>
                                    </div>
                                    <div class="row mb-2 mt-3">
                                        <ng-container *ngIf="quoteAssistModel.manufacturingProcess.addNewVisible">
                                            <div class="col-md-3">
                                                <div class="editable-textbox input-group d-flex align-items-center input-width">
                                                    <input type="text" class="form-control"
                                                        placeholder="Enter Process Name"
                                                        [(ngModel)]="this.manufacturingBlankSection.processName"
                                                        (keydown.enter)="saveNewManufacturingProcess()" />
                                                        <div class="input-group-append">
                                                            <span class="input-group-text">
                                                                <img src="assets/img/svg/pencil.svg" alt="Edit"/>
                                                            </span>
                                                        </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="editable-textbox input-group d-flex align-items-center input-width">
                                                    <input type="text" appOnlyPositiveNumbers
                                                        [(ngModel)]="this.manufacturingBlankSection.cycleTimePerUnit"
                                                        (keydown.enter)="saveNewManufacturingProcess()"
                                                        (change) = "calculateMachineTime(this.manufacturingBlankSection)"
                                                        class="form-control" placeholder="0" 
                                                        Manufacturing Processes/>
                                                        <div class="input-group-append">
                                                            <span class="input-group-text">
                                                                <img src="assets/img/svg/pencil.svg" alt="Edit" />
                                                            </span>
                                                        </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 p-0">
                                                <div class="editable-textbox input-group input-width">
                                                    <input type="text" 
                                                    [(ngModel)]="this.manufacturingBlankSection.totalMachineTimeInMinutes"
                                                    class="form-control disabled-input" placeholder="0" disabled />
                                                </div>
                                            </div>
                                            <div class="col-md-3 pr-0">
                                                <div class="editable-textbox input-group d-flex align-items-center input-width">
                                                    <input type="text" class="form-control" appOnlyPositiveNumbers
                                                        [(ngModel)]="this.manufacturingBlankSection.totalLaborTimeInMinutes"
                                                        (keydown.enter)="saveNewManufacturingProcess()"
                                                        placeholder="0" />
                                                        <div class="input-group-append">
                                                            <span class="input-group-text">
                                                                <img src="assets/img/svg/pencil.svg" alt="Edit" />
                                                            </span>
                                                        </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <!-- Add New Template for Manufacturing Ends-->

                                    <div class="notification-sec">
                                        <div class="notification-icon">
                                            <img src="assets/img/svg/notification-icon.svg" alt="Notification-icon" />
                                        </div>
                                        <div class="notification-text">
                                            <p>
                                                List each unique process for manufacturing this part. Quote Assist will
                                                learn and autofill these over time.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <button type="button" class="light-dark-blue"
                                            [ngClass]="{'disabled-btn': !this.quoteAssistModel.machining.isDataLoaded}"
                                            (click)="continueClicked($event, this.quoteAssistModel.machining, this.quoteAssistModel.manufacturingProcess)">
                                            Continue</button>
                                    </div>
                                </div>
                            </div>
                            <div class="material-row" (click)="showSection(this.quoteAssistModel.machining, true)"
                                [ngClass]="{'disabled-section-overlay': !quoteAssistModel.machining.isDataLoaded}">
                                <div class="heading-sec">
                                    <div>
                                        <h5>Machine Time (Cost)</h5>
                                    </div>
                                    <div>
                                        <img [src]="this.quoteAssistModel.machining.isSectionCompleted ? 'assets/img/svg/green-check.svg' : 'assets/img/svg/gray-check.svg'"
                                            alt="Check-icon" />
                                    </div>
                                </div>
                                <div class="collapseable-container" *ngIf="this.quoteAssistModel.machining.isVisible">
                                    <div class="row d-flex align-items-center mb-2 mt-2">
                                        <div class="col-md-4 pr-0">
                                            <label class="form-label">Process Step</label>
                                        </div>
                                        <div class="col-md-3 pr-0">
                                            <label class="form-label">Machine Time (Mins)</label>
                                        </div>
                                        <div class="col-md-2 pr-0">
                                            <label class="form-label">Cost/Min</label>
                                        </div>
                                        <div class="col-md-2 pr-0">
                                            <label class="form-label">Total Cost</label>
                                        </div>
                                        <div class="col-md-1"></div>
                                    </div>
                                    <div *ngFor="let machiningItem of quoteAssistModel?.manufacturingProcess?.manufacturingList"
                                        class="row d-flex align-items-center mb-2 mt-2">
                                        <div class="col-md-4 pr-0">
                                            <p>{{ machiningItem.processName }}</p>
                                        </div>
                                        <div class="col-md-3 pr-0">
                                            <div class="editable-textbox input-group">
                                                <input type="text" class="form-control disabled-input"
                                                    [(ngModel)]="machiningItem.totalMachineTimeInMinutes"
                                                    (ngModelChange)="multiplyMachineTimeAndCost(machiningItem)"
                                                    placeholder="0.00" appOnlyPositiveNumbers disabled />
                                            </div>
                                        </div>
                                        <div class="col-md-2 pr-0">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control"
                                                    [(ngModel)]="machiningItem.machineCostPerMinute"
                                                    (change)="quoteAssistModel.machining.calculateTotal()"
                                                    placeholder="0.00" [appFormatDecimal]="machiningItem.machineCostPerMinute" />
                                                <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        <img src="assets/img/svg/pencil.svg" alt="Edit" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2 pr-0">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control disabled-input" disabled
                                                    [(ngModel)]="machiningItem.totalMachiningCost" placeholder="0.00"
                                                    [appFormatDecimal]="machiningItem.totalMachiningCost" />
                                            </div>
                                        </div>
                                        <div class="col-md-1 d-flex align-items-center justify-content-end">
                                            <div class="remove-button" *ngIf="machiningItem.isEditable">
                                                <a (click)="editItem(machiningItem)">
                                                    <img src="assets/img/svg/close-x-lg.svg" alt="Remove icon"
                                                        style="height: 20px;" />
                                                </a>
                                            </div>
                                            <div class="remove-button"
                                                *ngIf="(quoteAssistModel?.machining?.machiningList?.length ?? 0) > 1 && !machiningItem.isEditable">
                                                <a (click)="removeManufacturingItem(machiningItem)">
                                                    <img src="assets/img/svg/delete-icon.svg" alt="Plus icon" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row d-flex align-items-center justify-content-end mb-2 mt-2">
                                        <div class="col-md-2">
                                            <label class="form-label">Total</label>
                                        </div>
                                        <div class="col-md-2 pr-0">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control disabled-input" 
                                                [(ngModel)]="this.quoteAssistModel.machining.totalCost" 
                                                [appFormatDecimal]="this.quoteAssistModel.machining.totalCost"
                                                placeholder="0.00" disabled />
                                            </div>
                                        </div>
                                        <div class="col-md-1"></div>
                                    </div>
                                    <div class="notification-sec">
                                        <div class="notification-icon">
                                            <img src="assets/img/svg/notification-icon.svg" alt="Notification-icon" />
                                        </div>
                                        <div class="notification-text">
                                            <p>
                                                Enter cost per minute for each process. Totals auto-calculate, and Quote
                                                Assist
                                                will pre-fill over time.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <button type="button" class="light-dark-blue"
                                            [ngClass]="{'disabled-btn': !this.quoteAssistModel.labor.isDataLoaded}"
                                            (click)="continueClicked($event, this.quoteAssistModel.labor, this.quoteAssistModel.machining)">Add To
                                            Quote</button>
                                    </div>
                                </div>
                            </div>
                            <div class="material-row" (click)="showSection(this.quoteAssistModel.labor, true)"
                                [ngClass]="{'disabled-section-overlay': !this.quoteAssistModel.labor.isDataLoaded}">
                                <div class="heading-sec">
                                    <div>
                                        <h5>Setup Time (Cost)</h5>
                                    </div>
                                    <div>
                                        <img [src]="this.quoteAssistModel.labor.isSectionCompleted ? 'assets/img/svg/green-check.svg' : 'assets/img/svg/gray-check.svg'"
                                            alt="Check-icon" />
                                    </div>
                                </div>
                                <div class="collapseable-container" *ngIf="this.quoteAssistModel.labor.isVisible">
                                    <div class="row d-flex align-items-center mb-2 mt-2">
                                        <div class="col-md-4 pr-0">
                                            <label class="form-label">Process Step</label>
                                        </div>
                                        <div class="col-md-3 pr-0">
                                            <label class="form-label">Setup Time (Mins)</label>
                                        </div>
                                        <div class="col-md-2 pr-0">
                                            <label class="form-label">Cost/Min</label>
                                        </div>
                                        <div class="col-md-2 pr-0">
                                            <label class="form-label">Total Cost</label>
                                        </div>
                                        <div class="col-md-1"></div>
                                    </div>
                                    <div *ngFor="let laborItem of quoteAssistModel?.manufacturingProcess?.manufacturingList"
                                        class="row d-flex align-items-center mb-2 mt-2">
                                        <div class="col-md-4 pr-0">
                                            <p>{{ laborItem.processName }}</p>
                                        </div>
                                        <div class="col-md-3 pr-0">
                                            <div class="editable-textbox input-group">
                                                <input type="text" class="form-control disabled-input"
                                                    [(ngModel)]="laborItem.totalLaborTimeInMinutes"
                                                    (ngModelChange)="multiplyLaborTimeAndCost(laborItem)"
                                                    placeholder="40" disabled />
                                            </div>
                                        </div>
                                        <div class="col-md-2 pr-0">
                                            <div class="editable-textbox input-group input-width">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control"
                                                    [(ngModel)]="laborItem.laborCostPerMinute"
                                                    (change)="quoteAssistModel.labor.calculateTotal()"
                                                    [appFormatDecimal]="laborItem.laborCostPerMinute"
                                                    placeholder="0.00" />
                                                <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        <img src="assets/img/svg/pencil.svg" alt="Edit" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2 pr-0">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control disabled-input"
                                                    [appFormatDecimal]="laborItem.totalLaborCost"
                                                    [(ngModel)]="laborItem.totalLaborCost" placeholder="0.00" disabled />
                                            </div>
                                        </div>
                                        <div class="col-md-1 d-flex align-items-center justify-content-end">
                                        </div>
                                    </div>
                                    <div class="row d-flex align-items-center justify-content-end mb-2 mt-2">
                                        <div class="col-md-2">
                                            <label class="form-label">Total</label>
                                        </div>
                                        <div class="col-md-2 pr-0">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control disabled-input" placeholder="0.00"
                                                    [(ngModel)]="this.quoteAssistModel.labor.totalCost"
                                                    [appFormatDecimal]="this.quoteAssistModel.labor.totalCost" disabled />
                                            </div>
                                        </div>
                                        <div class="col-md-1"></div>
                                    </div>

                                    <div class="notification-sec">
                                        <div class="notification-icon">
                                            <img src="assets/img/svg/notification-icon.svg" alt="Notification-icon" />
                                        </div>
                                        <div class="notification-text">
                                            <p>
                                                Enter cost per minute for each process. Totals auto-calculate, and Quote
                                                Assist
                                                will pre-fill over time.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <button type="button" class="light-dark-blue"
                                            [ngClass]="{'disabled-btn': !this.quoteAssistModel.additionalRequirements.isDataLoaded}"
                                            (click)="continueClicked($event, this.quoteAssistModel.additionalRequirements, this.quoteAssistModel.labor)">Add
                                            To Quote</button>
                                    </div>
                                </div>
                            </div>
                            <div class="material-row" (click)="showSection(this.quoteAssistModel.additionalRequirements, true)"
                                [ngClass]="{'disabled-section-overlay': !this.quoteAssistModel.additionalRequirements.isDataLoaded}">
                                <div class="heading-sec">
                                    <div>
                                        <h5>Additional Manufacturing Requirements</h5>
                                    </div>
                                    <div>
                                        <img [src]="this.quoteAssistModel.additionalRequirements.isSectionCompleted ? 'assets/img/svg/green-check.svg' : 'assets/img/svg/gray-check.svg'"
                                            alt="Check-icon" />
                                    </div>
                                </div>
                                <div class="collapseable-container"
                                    *ngIf="this.quoteAssistModel.additionalRequirements.isVisible">
                                    <div *ngFor="let additionalItem of quoteAssistModel?.additionalRequirements?.additionalRequirementList"
                                        class="row d-flex align-items-center mb-2 mt-3">
                                        <ng-container *ngIf="additionalItem.category === 'Primary'">
                                            <div class="col-md-7 pr-0" *ngIf="!additionalItem.isEditable">
                                                <strong>{{ additionalItem.processName }}</strong>
                                            </div>
                                            <div class="col-md-7 pr-0" *ngIf="additionalItem.isEditable">
                                                <div class="editable-textbox input-group">
                                                    <input type="text" class="form-control"
                                                        [(ngModel)]="additionalItem.processName"
                                                        (keydown.enter)="editItem(additionalItem)"
                                                        placeholder="Process Name" />
                                                </div>
                                            </div>
                                            <div class="col-md-4 pr-0">
                                                <div class="editable-textbox input-group">
                                                    <div class="input-group-append dollar-sign">
                                                        <span class="input-group-text">$</span>
                                                    </div>
                                                    <input type="text" class="form-control" placeholder="0.00"
                                                        (keydown.enter)="editItem(additionalItem)"
                                                        [appFormatDecimal]="additionalItem.estimatedCost"
                                                        [(ngModel)]="additionalItem.estimatedCost"
                                                        (change)="this.quoteAssistModel.additionalRequirements.calculateTotal()" />
                                                    <div class="input-group-append">
                                                        <span class="input-group-text">
                                                            <img src="assets/img/svg/pencil.svg" alt="Edit"
                                                                (click)="editItem(additionalItem)" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-1 d-flex align-items-center justify-content-end">
                                                <div class="remove-button" *ngIf="additionalItem.isEditable">
                                                    <a (click)="editItem(additionalItem)">
                                                        <img src="assets/img/svg/close-x-lg.svg" alt="Remove icon"
                                                            style="height: 20px;" />
                                                    </a>
                                                </div>

                                                <div class="remove-button" *ngIf="!additionalItem.isEditable">
                                                    <a (click)="removeAMRItem(additionalItem)">
                                                        <img src="assets/img/svg/delete-icon.svg" alt="Plus icon" />
                                                    </a>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>

                                    <!-- New input field for custom additional requirements -->
                                    <div class="row mb-2 mt-3">
                                        <div class="col-md-12 plus-icon"
                                            [ngClass]="{'opened': quoteAssistModel.additionalRequirements.addNewVisible}">
                                            <div class="icon-blue-line"></div>
                                            <a (click)="toggleAddNewTemplate(quoteAssistModel.additionalRequirements)">
                                                <i class="minus-plus-icon"></i>
                                                Add Other Process
                                            </a>
                                            <div class="icon-blue-line"></div>
                                        </div>
                                    </div>
                                    <div class="row mb-2 mt-3">
                                        <ng-container *ngIf="quoteAssistModel.additionalRequirements.addNewVisible">
                                            <div class="col-md-7 pr-0">
                                                <div class="editable-textbox input-group">
                                                    <input type="text" class="form-control"
                                                        placeholder="Enter Process Name"
                                                        [(ngModel)]="this.blankAMRSection.processName"
                                                        (keydown.enter)="saveNewAMR()" />
                                                </div>
                                            </div>
                                            <div class="col-md-4 pr-0">
                                                <div class="editable-textbox input-group">
                                                    <div class="input-group-append dollar-sign">
                                                        <span class="input-group-text">$</span>
                                                    </div>
                                                    <input type="text" class="form-control" placeholder="0.00"
                                                        [appFormatDecimal]="this.blankAMRSection.estimatedCost"
                                                        [(ngModel)]="this.blankAMRSection.estimatedCost"
                                                        (keydown.enter)="saveNewAMR()" />
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    
                                    <!--  additional total -->
                                    <div class="row d-flex align-items-center mb-2 mt-3">
                                        <div class="col-md-7">
                                            <strong>Total</strong>
                                        </div>
                                        <div class="col-md-4 pr-0">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control disabled-input" disabled
                                                    [value]="this.currentPartQty.summaryData.pricePerUnit.additionalManufacturingRequirements.totalCost | formatNumber"
                                                    placeholder="0.00" />
                                            </div>
                                        </div>
                                        <div class="col-md-1">
                                        </div>
                                    </div>

                                    <div class="notification-sec">
                                        <div class="notification-icon">
                                            <img src="assets/img/svg/notification-icon.svg" alt="Notification-icon" />
                                        </div>
                                        <div class="notification-text">
                                            <p>
                                                Provide specific costs for each post process listed as well as any cost
                                                for
                                                inspection of the part.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <button type="button" class="light-dark-blue"
                                            [ngClass]="{'disabled-btn': !this.quoteAssistModel.overhead.isDataLoaded}"
                                            (click)="continueClicked($event, this.quoteAssistModel.overhead, this.quoteAssistModel.additionalRequirements)">Add To
                                            Quote</button>
                                    </div>
                                </div>
                            </div>
                            <div class="material-row" (click)="showSection(this.quoteAssistModel.overhead, true)"
                                [ngClass]="{'disabled-section-overlay': !this.quoteAssistModel.overhead.isDataLoaded}">
                                <div class="heading-sec">
                                    <div>
                                        <h5>Overhead</h5>
                                    </div>
                                    <div>
                                        <img [src]="this.quoteAssistModel.overhead.isSectionCompleted ? 'assets/img/svg/green-check.svg' : 'assets/img/svg/gray-check.svg'"
                                            alt="Check-icon" />
                                    </div>
                                </div>
                                <div class="collapseable-container" *ngIf="this.quoteAssistModel.overhead.isVisible">
                                    <ng-container class="row d-flex align-items-center mb-2 mt-3"
                                        *ngFor="let overheadItem of quoteAssistModel?.overhead?.overheadList">
                                        <div class="row d-flex align-items-center mb-2 mt-3"
                                            *ngIf="overheadItem.category === 'Primary'">
                                            <div class="col-md-7 pr-0" *ngIf="!overheadItem.isEditable">
                                                <strong>{{ overheadItem.overheadTitle }}</strong>
                                            </div>
                                            <div class="col-md-7 pr-0" *ngIf="overheadItem.isEditable">
                                                <div class="editable-textbox input-group">
                                                    <input type="text" class="form-control"
                                                        [(ngModel)]="overheadItem.overheadTitle"
                                                        (keydown.enter)="editItem(overheadItem)"
                                                        placeholder="Process Name" />
                                                </div>
                                            </div>
                                            <div class="col-md-4 pr-0">
                                                <div class="editable-textbox input-group">
                                                    <div class="input-group-append dollar-sign">
                                                        <span class="input-group-text">$</span>
                                                    </div>
                                                    <input type="text" class="form-control"
                                                        [appFormatDecimal]="overheadItem.estimatedCost"
                                                        [(ngModel)]="overheadItem.estimatedCost"
                                                        (change)="this.quoteAssistModel.overhead.calculateTotal()"
                                                         placeholder="0.00" />
                                                    <div class="input-group-append">
                                                        <span class="input-group-text">
                                                            <img src="assets/img/svg/pencil.svg" alt="Edit"
                                                                (click)="editItem(overheadItem)" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-1 d-flex align-items-center justify-content-end">
                                                <div class="remove-button" *ngIf="overheadItem.isEditable">
                                                    <a (click)="editItem(overheadItem)">
                                                        <img src="assets/img/svg/close-x-lg.svg" alt="Remove icon"
                                                            style="height: 20px;" />
                                                    </a>
                                                </div>
                                                <div class="remove-button" *ngIf="!overheadItem.isEditable">
                                                    <a (click)="removeOverheadItem(overheadItem)">
                                                        <img src="assets/img/svg/delete-icon.svg" alt="Plus icon" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <!-- New input field for custom overhead requirements -->
                                    <div class="row mb-2 mt-3">
                                        <div class="col-md-12 plus-icon"
                                            [ngClass]="{'opened': quoteAssistModel.overhead.addNewVisible}">
                                            <div class="icon-blue-line"></div>
                                            <a (click)="toggleAddNewTemplate(quoteAssistModel.overhead)">
                                                <i class="minus-plus-icon"></i>
                                                Add Other Process
                                            </a>
                                            <div class="icon-blue-line"></div>
                                        </div>
                                    </div>
                                    <div class="row mb-2 mt-3">
                                        <ng-container *ngIf="quoteAssistModel.overhead.addNewVisible">
                                            <div class="col-md-7 pr-0">
                                                <div class="editable-textbox input-group">
                                                    <input type="text" class="form-control"
                                                        placeholder="Enter Overhead Name"
                                                        [(ngModel)]="this.blankOverheadSection.overheadTitle"
                                                        (keydown.enter)="saveNewOverhead()"/>
                                                </div>
                                            </div>
                                            <div class="col-md-4 pr-0">
                                                <div class="editable-textbox input-group">
                                                    <div class="input-group-append dollar-sign">
                                                        <span class="input-group-text">$</span>
                                                    </div>
                                                    <input type="text" class="form-control" placeholder="0.00"
                                                        [appFormatDecimal]="this.blankOverheadSection.estimatedCost"
                                                        [(ngModel)]="this.blankOverheadSection.estimatedCost"
                                                        (keydown.enter)="saveNewOverhead()" />
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>

                                    <div class="row d-flex align-items-center mb-2 mt-3">
                                        <div class="col-md-7">
                                            <strong>Total</strong>
                                            <div class="tooltip-container">
                                                <img src="assets/img/svg/tooltip-icon.png" alt="Tooltip" class="tooltip-icon" (click)="toggleTooltip($event)">
                                                <div class="tooltip-popup">
                                                    Note: The overhead amount applies to the entire RFQ, not just this part.
                                                </div>
                                            </div>                          
                                        </div>
                                        <div class="col-md-4 pr-0">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control disabled-input" disabled
                                                    [value]="this.currentPartQty.summaryData.pricePerUnit.overhead.totalCost | formatNumber"
                                                    placeholder="0.00" />
                                            </div>
                                        </div>
                                        <div class="col-md-1">
                                        </div>
                                    </div>

                                    <div class="notification-sec">
                                        <div class="notification-icon">
                                            <img src="assets/img/svg/notification-icon.svg" alt="Notification-icon" />
                                        </div>
                                        <div class="notification-text">
                                            <p>
                                                Enter general overhead rates. Total overhead will auto-calculate, and
                                                Quote
                                                Assist will save your input for future use.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <button type="button" class="light-dark-blue"
                                            [ngClass]="{'disabled-btn': !this.quoteAssistModel.otherCosts.isDataLoaded}"
                                            (click)="continueClicked($event, this.quoteAssistModel.otherCosts, this.quoteAssistModel.overhead)">Add To
                                            Quote</button>
                                    </div>
                                </div>
                            </div>
                            <div class="material-row" (click)="showSection(this.quoteAssistModel.otherCosts, true)"
                                [ngClass]="{'disabled-section-overlay': !this.quoteAssistModel.otherCosts.isDataLoaded}">
                                <div class="heading-sec">
                                    <div>
                                        <h5>Other Costs</h5>
                                    </div>
                                    <div>
                                        <img [src]="this.quoteAssistModel.otherCosts.isSectionCompleted ? 'assets/img/svg/green-check.svg' : 'assets/img/svg/gray-check.svg'"
                                            alt="Check-icon" />
                                    </div>
                                </div>
                                <div class="collapseable-container" *ngIf="this.quoteAssistModel.otherCosts.isVisible">
                                    <div class="row d-flex align-items-center mb-2 mt-2">
                                        <div class="col-md-8 pr-0">
                                            <label class="form-label">Process Step</label>
                                        </div>
                                        <div class="col-md-3 pr-0">
                                            <label class="form-label">Amount</label>
                                        </div>
                                        <div class="col-md-1"></div>
                                    </div>
                                    <div *ngFor="let otherItem of quoteAssistModel?.otherCosts?.otherCostList"
                                        class="row d-flex align-items-center mb-2 mt-2">
                                        <div class="col-md-8 pr-0">
                                            <strong>{{otherItem.processName}}</strong>
                                        </div>
                                        <div class="col-md-3 pr-0">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control" placeholder="0.00"
                                                    (keydown.enter)="editItem(otherItem)"
                                                    [appFormatDecimal]="otherItem.estimatedCost"
                                                    [(ngModel)]="otherItem.estimatedCost"
                                                    (change)="quoteAssistModel.otherCosts.calculateTotal();" />
                                                <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        <img src="assets/img/svg/pencil.svg" alt="Edit" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-1 d-flex align-items-center justify-content-end">
                                            <div class="remove-button" *ngIf="otherItem.isEditable">
                                                <a (click)="editItem(otherItem)">
                                                    <img src="assets/img/svg/close-x-lg.svg" alt="Remove icon"
                                                        style="height: 20px;" />
                                                </a>
                                            </div>
                                            <div class="remove-button"
                                                *ngIf="!otherItem.isEditable">
                                                <a (click)="removeOtherCostItem(otherItem)">
                                                    <img src="assets/img/svg/delete-icon.svg" alt="Plus icon" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- New input field for Custom Other Costs -->
                                    <div class="row mb-2 mt-3">
                                        <div class="col-md-12 plus-icon"
                                            [ngClass]="{'opened': quoteAssistModel.otherCosts.addNewVisible}">
                                            <div class="icon-blue-line"></div>
                                            <a (click)="toggleAddNewTemplate(quoteAssistModel.otherCosts)">
                                                <i class="minus-plus-icon"></i>
                                                Add Other Process
                                            </a>
                                            <div class="icon-blue-line"></div>
                                        </div>
                                    </div>
                                    <div class="row mb-2 mt-3">
                                        <ng-container *ngIf="quoteAssistModel.otherCosts.addNewVisible">
                                            <div class="col-md-8 pr-0">
                                                <div class="editable-textbox input-group">
                                                    <input type="text" class="form-control"
                                                        placeholder="Enter Process Name"
                                                        [(ngModel)]="this.blankOtherSection.processName"
                                                        (keydown.enter)="saveNewOtherCost()" />
                                                </div>
                                            </div>
                                            <div class="col-md-3 pr-0">
                                                <div class="editable-textbox input-group">
                                                    <div class="input-group-append dollar-sign">
                                                        <span class="input-group-text">$</span>
                                                    </div>
                                                    <input type="text" class="form-control" placeholder="0.00"
                                                        [appFormatDecimal]="this.blankOtherSection.estimatedCost"
                                                        [(ngModel)]="this.blankOtherSection.estimatedCost"
                                                        (keydown.enter)="saveNewOtherCost()" />
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <!-- New input field for Custom Other Costs -->

                                    <div class="row d-flex align-items-center mb-2 mt-3">
                                        <div class="col-md-8 pr-0">
                                            <strong>Total</strong>
                                            <div class="tooltip-container">
                                                <img src="assets/img/svg/tooltip-icon.png" alt="Tooltip" class="tooltip-icon" (click)="toggleTooltip($event)">
                                                <div class="tooltip-popup">
                                                    Note: Other costs apply to the entire RFQ, not just this part.
                                                </div>
                                            </div> 
                                        </div>
                                        <div class="col-md-3 pr-0">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control initial-input disabled-input"
                                                    [value]="quoteAssistModel.otherCosts.totalCost | formatNumber"
                                                    placeholder="0.00" disabled />
                                            </div>
                                        </div>
                                        <div class="col-md-1"></div>
                                    </div>
                                    <div class="notification-sec">
                                        <div class="notification-icon">
                                            <img src="assets/img/svg/notification-icon.svg" alt="Notification-icon" />
                                        </div>
                                        <div class="notification-text">
                                            <p>
                                                Enter any other costs that are associated with this job. We'll try to infer 
                                                this information in the future.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <button type="button" class="light-dark-blue"
                                            [ngClass]="{'disabled-btn': !this.quoteAssistModel.profit.isDataLoaded}"
                                            (click)="continueClicked($event, this.quoteAssistModel.shipping, this.quoteAssistModel.otherCosts)">Add To
                                            Quote</button>
                                    </div>
                                </div>
                            </div>
                            <div class="material-row" (click)="showSection(this.quoteAssistModel.shipping, true)"
                                [ngClass]="{'disabled-section-overlay': !this.quoteAssistModel.shipping.isDataLoaded}">
                                <div class="heading-sec">
                                    <div>
                                        <h5>Shipping & Handling</h5>
                                    </div>
                                    <div>
                                        <img [src]="this.quoteAssistModel.shipping.isSectionCompleted ? 'assets/img/svg/green-check.svg' : 'assets/img/svg/gray-check.svg'"
                                            alt="Check-icon" />
                                    </div>
                                </div>
                                <div class="collapseable-container" *ngIf="this.quoteAssistModel.shipping.isVisible">
                                    <div class="row d-flex align-items-center mb-2 mt-3">
                                        <div class="col-md-6">
                                            <strong>Shipping</strong>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control"
                                                    [(ngModel)]="quoteAssistModel.shipping.shippingCharges"
                                                    placeholder="0.00"
                                                    [appFormatDecimal]="quoteAssistModel.shipping.shippingCharges"
                                                    (change)="quoteAssistModel.shipping.calculateTotal(); updateGrandTotal()" />
                                                <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        <img src="assets/img/svg/pencil.svg" alt="Edit" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row d-flex align-items-center mb-2 mt-3">
                                        <div class="col-md-6">
                                            <strong>Handling</strong>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control"
                                                    [(ngModel)]="quoteAssistModel.shipping.handlingCharges"
                                                    placeholder="0.00"
                                                    [appFormatDecimal]="quoteAssistModel.shipping.handlingCharges"
                                                    (change)="quoteAssistModel.shipping.calculateTotal(); updateGrandTotal();" />
                                                <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        <img src="assets/img/svg/pencil.svg" alt="Edit" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row d-flex align-items-center mb-2 mt-3">
                                        <div class="col-md-6">
                                            <strong>Total Shipping & Handling Cost</strong> 
                                            <div class="tooltip-container">
                                                <img src="assets/img/svg/tooltip-icon.png" alt="Tooltip" class="tooltip-icon" (click)="toggleTooltip($event)">
                                                <div class="tooltip-popup">
                                                    Note: Shipping and handling apply to the entire RFQ, not just this part. They affect your total cost but are not included in the per-unit price.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control initial-input disabled-input"
                                                    [appFormatDecimal]="quoteAssistModel.shipping.totalCost"
                                                    [(ngModel)]="quoteAssistModel.shipping.totalCost"
                                                    placeholder="0.00" disabled />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="notification-sec">
                                        <div class="notification-icon">
                                            <img src="assets/img/svg/notification-icon.svg" alt="Notification-icon" />
                                        </div>
                                        <div class="notification-text">
                                            <p>
                                                Estimated general shipping costs. Please ensure that these are correct
                                                for
                                                your
                                                general work.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <button type="button" class="light-dark-blue"
                                            [ngClass]="{'disabled-btn': !this.quoteAssistModel.shipping.isDataLoaded}"
                                            (click)="continueClicked($event, this.quoteAssistModel.profit, this.quoteAssistModel.shipping)">Add To
                                            Quote</button>
                                    </div>
                                </div>
                            </div>
                            <div class="material-row" (click)="showSection(this.quoteAssistModel.profit, true)"
                                [ngClass]="{'disabled-section-overlay': !this.quoteAssistModel.profit.isDataLoaded}">
                                <div class="heading-sec">
                                    <div>
                                        <h5>Profit Margin</h5>
                                    </div>
                                    <div>
                                        <img [src]="this.quoteAssistModel.profit.isSectionCompleted ? 'assets/img/svg/green-check.svg' : 'assets/img/svg/gray-check.svg'"
                                            alt="Check-icon" />
                                    </div>
                                </div>
                                <div class="collapseable-container" *ngIf="this.quoteAssistModel.profit.isVisible">
                                    <div class="row d-flex align-items-center mb-2 mt-3">
                                        <div class="col-md-7">
                                            <strong>Target Profit Margin</strong>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">%</span>
                                                </div>
                                                <input type="text" class="form-control"
                                                    [(ngModel)]="quoteAssistModel.profit.industryStandardProfitMargin"
                                                    (blur)="calculateAllSections();updateGrandTotal();"
                                                    [appFormatDecimal]="quoteAssistModel.profit.industryStandardProfitMargin"
                                                    placeholder="0" />
                                                <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        <img src="assets/img/svg/pencil.svg" alt="Edit" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row d-flex align-items-center mb-2 mt-3">
                                        <div class="col-md-7">
                                            <strong>Total Cost</strong>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control disabled-input initial-input"
                                                    [appFormatDecimal]="quoteAssistModel.profit.totalCost"
                                                    [(ngModel)]="quoteAssistModel.profit.totalCost" 
                                                    placeholder="0.00" [disabled]="true" />
                                            </div>
                                        </div>
                                    </div>
                                
                                    <div class="row d-flex align-items-center mb-2 mt-3">
                                        <div class="col-md-7">
                                            <strong>Total Price</strong>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="editable-textbox input-group">
                                                <div class="input-group-append dollar-sign">
                                                    <span class="input-group-text">$</span>
                                                </div>
                                                <input type="text" class="form-control disabled-input initial-input"
                                                    [appFormatDecimal]="quoteAssistModel.profit.totalPrice"
                                                    [(ngModel)]="quoteAssistModel.profit.totalPrice" 
                                                    placeholder="0.00" [disabled]="true"/>
                                            </div>
                                        </div>
                                    </div>
                                    

                                    <div class="notification-sec">
                                        <div class="notification-icon">
                                            <img src="assets/img/svg/notification-icon.svg" alt="Notification-icon" />
                                        </div>
                                        <div class="notification-text">
                                            <p>
                                                Set your desired profit margin to adjust the total price based on the
                                                part's
                                                initial cost.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <button type="button" class="light-dark-blue" (click)="proceedToQuote()">Proceed
                                            To
                                            Quote Summary</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-fixed">
                <div class="col-md-4">
                    <div class="footer-left-sec">
                        <!-- <button type="button" class="btn" (click)="this.currentPart.quoteAssistData.quoteModelLoaded ? saveDraft() : null">
                            Save to draft</button> -->
                        <a (click)="this.currentPart.quoteAssistData.quoteModelLoaded ? skipQuoteAssist() : null">Quote Manually</a>
                        <div class="tooltip-container">
                            <img src="assets/img/svg/tooltip-icon.png" alt="Tooltip" class="tooltip-icon" (click)="toggleTooltip($event)">
                            <div class="tooltip-popup">
                                Skip automated quoting and submit your values manually.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="footer-right-sec">
                        <div class="total-quote">
                            <span>Quantity 1 </span>
                            <span>Total </span>
                            <span class="unit-qty" *ngIf="this.currentPart?.quoteAssistData">({{
                                this.currentPart.quoteAssistData.assistedQty }} units)</span>
                        </div>
                        <div class="quote-total-value">${{ this.quoteGrandTotal | formatNumber }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="full-page-overlay" *ngIf="showPageDataLoading">
        <div class="rfqLoader"></div>
    </div>
</div>